/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Businesses from "./businesses/Businesses";
import BusinessDashboard from "./business-dashboard/BusinessDashboard";
import BusinessSupport from "./business-support/BusinessSupport";
import OpenTickets from "./tickets/OpenTickets";
import CloseTickets from "./tickets/CloseTickets";
import ContactUs from './tickets/ContactUs'
import Seo from "./seo/Seo";
import { Link, Routes, Route } from "react-router-dom";
import BusinessRejectedReport from "./business-rejected-report/BusinessRejectedReport";
import BusinessUnderReviewReport from "./business-under-review-report/BusinessUnderReviewReport";
import BusinessSaleReport from "./business-sale-report/BusinessSaleReport";
import EndorsementRejectedReport from "./endorsement-rejected-report/EndorsementRejectedReport";
import EndorsementUnderReviewReport from "./endorsement-underReview-report/EndorsementUnderReviewReport";
import EndorsementPendingPaymentReport from "./endorsement-pendingPayment-report/EndorsementPendingPaymentReport";
import IssueEndorsementReport from "./issue-endorsement-report/IssueEndorsementReport"
import AgentsBalance from "./business-agents-balance/AgentsBalance";
import AgentPaid from "./agents-paid/AgentPaid";
import UserReport from "./user-report/UserReport";
import Users from "./users/Users";
import BlogPosts from "./blog-roll/BlogPosts";
import MarketerBalanceReport from "./marketers-balance-report/MarketerBalanceReport";
import Notifications from "./notifications/Notifications";
import ExternalLoginTest from "./external-login-test";
import Layout from "./Layout";
import Content from "./Content";
import MainContent from "./MainContent";
import { readStoredGridCols, writeStoredGridCols } from "./GridSizeToggle";
import { useView } from "../hooks/useView";
import Profile from "./Profile";
import ChangePassword from "../components/setting/ChangePassword";
import WhiteLabelSettings from "../components/WhiteLabelSettings";
import MarketerWageSettings from "../components/MarketerWageSettings";
import { Collapse, Spin } from "antd";
import BusinessRenewalReport from "./business-Renewal-report/BusinessRenewalReport";
import CompanySaleReport from "./company-sale-report/CompanySaleReport";
import BusinessPendingPayment from "./business-pending-payment/BusinessPendingPayment";
import SlidesManagement from "./managements/slides-managment/SlidesManagement";
import ReturnedReports from "./returned-reports/ReturnedReports";
import { WaitingToReturn } from "./returned-reports/WaitingToReturn";
import PageLogReport from "./page-log-daily-report/PageLogReport";
import BusinessOtpReport from "./business-otp-report/BusinessOtpReport";
import UsersBusinessReport from "./user-business-report/UsersBusinessReport";
import CallHistory from "./CallHistory";
import MyCallHistories from "./users/MyCallHistories";
import Receipts from "./receipts/Receipts";
import ReceiptsReport from "./receipts/ReceiptsReport";
import { useLocation } from "react-router-dom";
import Feedback from "./companies/Feedback";
import { usePersistedStore } from "../store/persisted-store";
import BusinessCanceledReport from "./business-canceled-report/BusinessCanceledReport";
import MarketersList from "./marketers-list/MarketersList";
import PlaqueReport from "./plaque-report/PlaqueReport";
import WLFundReport from "./white-lable-settelment-fund-report/WLFundReport";
import PromoterUsersReport from "./promoter-users-report/PromoterUsersReport";
import BusinessInstallmentReport from "./business-installment-report/BusinessInstallmentReport";

const { Panel } = Collapse;

export default function Dashborad() {

  const { RESET_APP, logOut, auth, business } = usePersistedStore()
  const location = useLocation();
  const url = location.pathname.split('/')[1];
  const userInfo = auth.userInfo;
  const currentBusiness = business?.currentBusiness;
  const data = currentBusiness?.data;
  const token = currentBusiness?.token;
  const logoLoading = business?.businesses?.loading;
  const businessLogo = data?.logo;
  const businessType = data?.type
  const businessId = data?.id

  const [showLogo, setShowLogo] = useState(businessLogo);
  const [isMarketer, setIsMarketer] = useState(false);
  const [hasTicketingService, setHasTicketingService] = useState(false);


  const [pageTitle, setPageTitle] = useState("صفحه اصلی");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [gridCols, setGridCols] = useState(() => readStoredGridCols());
  const isHomePage = location.pathname === '/dashboard' || location.pathname === '/dashboard/';
  const { isMobile, isTablet } = useView();
  const isCompactView = isMobile || isTablet;

  const handleGridColsChange = (cols) => {
    setGridCols(cols);
    writeStoredGridCols(cols);
  };

  const userResources = auth.userInfo?.Resources;
  const updateBusinessResource = userResources?.includes("UpdateBusiness")

  const selectTitle = () => {

    switch (location.pathname) {

      case '/dashboard/users/1':
        return setPageTitle("مدیریت کاربران");
      case '/dashboard/marketers-list':
        return setPageTitle("لیست بازاریابان");
      case '/dashboard/businesses':
        return setPageTitle("مدیریت شرکای تجاری");
      case '/dashboard/posts':
        return setPageTitle("مدیریت بلاگ");
      case '/dashboard/seo':
        return setPageTitle("مدیریت سئو");
      case '/dashboard/feedback':
        return setPageTitle("کارتابل نظرات");
      case '/dashboard/slidesManagmanet':
        return setPageTitle("مدیریت اسلایدها");
      case '/dashboard/whiteLabelSettings':
        return setPageTitle("تنظیمات وایت لیبل");
      case '/dashboard/marketerWageSettings':
        return setPageTitle("تنظیمات کارمزد بازاریاب ها");
      case '/dashboard/promoter-users':
        return setPageTitle("جستجوی بازاریاب");
      case '/dashboard/agents-paid':
        return setPageTitle("پرداخت بازاریاب ها");
      case '/dashboard/agents-balance':
        return setPageTitle("گزارش مانده بازاریابها");
      case '/dashboard/marketers-remain-report':
        return setPageTitle("گردش حساب یک بازاریاب");
      case '/dashboard/returned-reports':
        return setPageTitle("گزارش عودتی‌ها");
      case '/dashboard/awaiting-returned-reports':
        return setPageTitle("گزارش در انتظار عودت مالی");
      case '/dashboard/business-rejected-report':
        return setPageTitle("درخواستهای رد شده");
      case '/dashboard/business-under-review-report':
        return setPageTitle("درخواستهای در حال بررسی");
      case '/dashboard/business-pending-payment':
        return setPageTitle("درخواستهای در انتظار پرداخت مابه تفاوت");
      case '/dashboard/issue-endorsement-report':
        return setPageTitle("گزارش صدور الحاقیه");
      case '/dashboard/endorsement/rejected-report':
        return setPageTitle(" الحاقیه‌های رد شده");
      case '/dashboard/endorsement/under-review-report':
        return setPageTitle("الحاقیه‌های در حال بررسی");
      case '/dashboard/endorsement/pending-payment-report':
        return setPageTitle("الحاقیه‌های در انتظار پرداخت");
      case '/dashboard/business-sale-report':
        return setPageTitle("گزارش فروش");
      case '/dashboard/business-installment-report':
        return setPageTitle("گزارش اقساط");
      case '/dashboard/business-support':
        return setPageTitle("گزارش پشتیبانی");
      case '/dashboard/business-Renewal-report':
        return setPageTitle(" گزارش تمدید");
      case '/dashboard/company-sale-report':
        return setPageTitle(" گزارش فروش شرکت");
      case '/dashboard/page-log-daily-report':
        return setPageTitle("گزارش بازدید");
      case '/dashboard/plaque-report':
        return setPageTitle("گزارش استعلام پلاک");
      case '/dashboard/white-lable-settelment-fund-report':
        return setPageTitle("گزارش تراکنش");
      case '/dashboard/business-dashboard':
        return setPageTitle("خلاصه عملکرد سازمان");
      case '/dashboard/user-business-report':
        return setPageTitle("جست و جوی کاربر");
      case '/dashboard/call-history':
        return setPageTitle("گزارش تماس");
      case '/dashboard/my-call-histories':
        return setPageTitle("تماس های من");
      case '/dashboard/open-tickets':
        return setPageTitle("تیکت‌های باز");
      case '/dashboard/close-tickets':
        return setPageTitle("تیکت‌های بسته");
      case '/dashboard/contact-us':
        return setPageTitle("تماس با ما");
      case '/dashboard/otp-report':
        return setPageTitle(" گزارش otp");
      case '/dashboard/receipts':
        return setPageTitle("فاکتورها");
      case '/dashboard/receipts-report':
        return setPageTitle("گزارش پشتیبانی فاکتورها");
      case '/dashboard/notifications':
        return setPageTitle("اعلان ها");
      case '/dashboard/external-login-test':
        return setPageTitle("تست اکسترنال لاگین");
      default:
        return setPageTitle("صفحه اصلی");
    }

  }

  useEffect(() => {
    selectTitle();
    setIsMarketer(currentBusiness?.data?.marketerSystem);
    setHasTicketingService(currentBusiness?.data?.hasTicketingService);
    if (token) {
      setShowLogo(businessLogo)
    }

  }, [currentBusiness, token])

  useEffect(() => {
    const primaryColor = currentBusiness?.data?.styles?.primaryColor;
    document.documentElement.style.setProperty('--brand-primary', primaryColor || '#556ee6');
    if (!primaryColor) return;

    let styleTag = document.getElementById('business-theme-style-active');
    if (!styleTag) {
      styleTag = document.createElement('style');
      styleTag.id = 'business-theme-style-active';
      document.head.appendChild(styleTag);
    }

    styleTag.innerHTML = `
        #sidebar-menu .metismenu a.active-link,
        #sidebar-menu .metismenu .sub-menu a.active-link {
            color: ${primaryColor} !important;
            font-weight: 600;
            i {
            color: ${primaryColor}
            }
        }
    `;
  }, [currentBusiness]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);


  const isActive = (path) => location.pathname === path;

  const handleTitle = (title) => {
    setPageTitle(title);
  };

  return (
    <div className="container-fluid dashboard-container">
      <Layout onPageTile={(title) => handleTitle(title)}>
        <div className="vertical-menu">
          <div className="h-100">
            <div className="user-wid text-center pt-4 pb-2">
              <div className="logo-img">
                <Spin spinning={logoLoading}>
                  {showLogo ?
                    <img
                      src={showLogo}
                      alt={currentBusiness.name}
                      className="avatar-md mx-auto rounded-rectangle"
                    /> : <></>}
                </Spin>
              </div>
              <div className="mt-3 d-flex pl-3">
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="48" fill="none">   <path d="M23.902 45c11.598 0 21-9.402 21-21s-9.402-21-21-21-21 9.402-21 21 9.402 21 21 21z" fill="#f6f6f6"></path>   <path fill="#e3e3e3" d="M24.335 25.162c-.14-.02-.32-.02-.48 0a6.54 6.54 0 0 1-6.32-6.54 6.55 6.55 0 0 1 6.56-6.56c3.62 0 6.56 2.94 6.56 6.56-.02 3.54-2.8 6.42-6.32 6.54zm13.242 13.197a19.868 19.868 0 0 1-13.48 5.24c-5.2 0-9.92-1.98-13.48-5.24.2-1.88 1.4-3.72 3.54-5.16 5.48-3.64 14.44-3.64 19.88 0 2.14 1.44 3.34 3.28 3.54 5.16z" class="fill-lighter-surface-color" stroke="#e3e3e3" stroke-width="2" stroke-linejoin="round"></path> </svg>
                </div>
                <div className="display-name ml-2 d-flex flex-column gap-1">
                  <div style={{ color: '#707d8a', fontSize: 12 }}>پنل مدیریت</div>
                  <div className="text-start">{userInfo && userInfo.DisplayName}</div>
                </div>
              </div>
            </div>
            <div id="sidebar-menu" className="sidebar-menu">
              <ul className="metismenu list-unstyled" id="side-menu">
                <li>
                  <Link
                    className={`sidebar-panel ${isActive('/dashboard') ? 'active-link' : ''}`}
                    // className="sidebar-panel" 
                    to={`/dashboard`} onClick={() => setPageTitle("صفحه اصلی")}>
                    <span className="sidebarHeader">
                      <i className="mdi mdi-home-lightbulb"></i>
                      <span className="title">خانه</span>
                    </span>
                  </Link>
                </li>
                <li className="background-transparent">
                  <Collapse bordered={false} accordion>
                    {userResources &&
                      (userResources?.includes("UserManagment") ||
                        userResources?.includes("BusinessesManagment") ||
                        userResources?.includes("BlogManagment") ||
                        userResources?.includes("SeoManagment") ||
                        userResources?.includes("CompaniesManagment") ||
                        userResources?.includes("CompanyFeedback") ||
                        userResources?.includes("EditDesign") ||
                        userResources?.includes("BusinessAdmin") ||
                        userResources?.includes("MarketersReports") ||
                        userResources?.includes("FileUpload")) && (

                        <Panel
                          showArrow={false}
                          className="sidebar-panel"
                          header={
                            <span className="sidebarHeader">
                              <i className="mdi mdi-shield-account"></i>
                              <span className="title">مدیریت</span>
                              <i className="mdi mdi-chevron-down expand-icon" />
                            </span>
                          }
                          key="1"
                          bordered={false}
                        >
                          <ul className="sub-menu">
                            {userResources &&
                              userResources?.includes("UserManagment") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive(`/dashboard/users/1`) ? 'active-link' : ''}`}
                                    to={`/${url}/users/1`}
                                    onClick={() =>
                                      setPageTitle("مدیریت کاربران")
                                    }
                                  >
                                    مدیریت کاربران
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("MarketersReports") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/marketers-list') ? 'active-link' : ''}`}
                                    to={`/${url}/marketers-list`}
                                    onClick={() =>
                                      setPageTitle("لیست بازاریابان")
                                    }
                                  >
                                    لیست بازاریابان
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("BusinessesManagment") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/businesses') ? 'active-link' : ''}`}

                                    to={`/${url}/businesses`}
                                    onClick={() =>
                                      setPageTitle("مدیریت شرکای تجاری")
                                    }
                                  >
                                    مدیریت شرکای تجاری
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("BlogManagment") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/posts') ? 'active-link' : ''}`}

                                    to={`/${url}/posts`}
                                    onClick={() => setPageTitle("مدیریت بلاگ")}
                                  >
                                    مدیریت بلاگ
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("SeoManagment") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/seo') ? 'active-link' : ''}`}

                                    to={`/${url}/seo`}
                                    onClick={() => setPageTitle("مدیریت سئو")}
                                  >
                                    مدیریت سئو
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("CompanyFeedback") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/feedback') ? 'active-link' : ''}`}

                                    to={`/${url}/feedback`}
                                    onClick={() =>
                                      setPageTitle(" کارتابل نظرات")
                                    }
                                  >
                                    کارتابل نظرات
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              userResources?.includes("AddSliderImage") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/slidesManagmanet') ? 'active-link' : ''}`}

                                    to={`/${url}/slidesManagmanet`}
                                    onClick={() =>
                                      setPageTitle("مدیریت اسلایدها")
                                    }
                                  >
                                    مدیریت اسلایدها
                                  </Link>
                                </li>
                              )}
                            {userResources &&
                              updateBusinessResource &&
                              userResources?.includes("EditDesign") && (businessType === 2 || businessId === 13) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/whiteLabelSettings') ? 'active-link' : ''}`}

                                    to={`/${url}/whiteLabelSettings`}
                                    onClick={() =>
                                      setPageTitle("تنظیمات وایت لیبل")
                                    }
                                  >
                                    تنظیمات وایت لیبل
                                  </Link>
                                </li>
                              )}
                            {isMarketer &&
                              userResources &&
                              userResources?.includes("BusinessAdmin") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/marketerWageSettings') ? 'active-link' : ''}`}

                                    to={`/${url}/marketerWageSettings`}
                                    onClick={() =>
                                      setPageTitle("تنظیمات کارمزد بازاریاب ها")
                                    }
                                  >
                                    تنظیمات کارمزد بازاریاب ها
                                  </Link>
                                </li>
                              )}
                            {
                              userResources?.includes("BusinessesManagment") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/external-login-test') ? 'active-link' : ''}`}

                                    to={`/${url}/external-login-test`}
                                    onClick={() =>
                                      setPageTitle("تست اکسترنال لاگین")
                                    }
                                  >
                                    تست اکسترنال لاگین
                                  </Link>
                                </li>
                              )
                            }
                          </ul>
                        </Panel>
                      )}
                    {userResources &&
                      // ((userResources?.includes("MarketersReports") && isMarketer) ||
                      //   (userResources?.includes("MarketersPaid") && isMarketer) ||
                      //   userResources?.includes("BusinessDeposit") && isMarketer) &&
                      <Panel
                        showArrow={false}
                        className="sidebar-panel"
                        header={
                          <span className="sidebarHeader">
                            <i className="mdi mdi-coin-outline"></i>
                            <span className="title">مالی</span>
                            <i className="mdi mdi-chevron-down expand-icon" />
                          </span>
                        }
                        key="2"
                        bordered={false}
                      >
                        <ul className="sub-menu">
                          {userResources?.includes("MarketersReports") && isMarketer && (
                            <li><Link
                              className={`sidebar-panel ${isActive('/dashboard/agents-balance') ? 'active-link' : ''}`}
                              to={`/${url}/agents-balance`} onClick={() => setPageTitle("گزارش مانده بازاریابها")}>گزارش مانده بازاریابها</Link></li>)}
                          {userResources?.includes("MarketersReports") && isMarketer && (
                            <li><Link
                              className={`sidebar-panel ${isActive('/dashboard/marketers-remain-report') ? 'active-link' : ''}`}
                              to={`/${url}/marketers-remain-report`} onClick={() => setPageTitle("گردش حساب یک بازاریاب")}>گردش حساب یک بازاریاب</Link></li>)}
                          {userResources?.includes("MarketersPaid") && isMarketer && (
                            <li><Link
                              className={`sidebar-panel ${isActive('/dashboard/agents-paid') ? 'active-link' : ''}`}
                              to={`/${url}/agents-paid`} onClick={() => setPageTitle("پرداخت بازاریاب ها")}>پرداخت بازاریاب ها</Link></li>)}
                          {userResources?.includes("BusinessDeposit") &&
                            (<li><Link
                              className={`sidebar-panel ${isActive('/dashboard/returned-reports') ? 'active-link' : ''}`}
                              to={`/${url}/returned-reports`} onClick={() => setPageTitle("گزارش عودتی‌ها")}>گزارش عودتی‌ها</Link></li>)}
                          {userResources?.includes("BusinessDeposit") && (
                            <li><Link
                              className={`sidebar-panel ${isActive('/dashboard/awaiting-returned-reports') ? 'active-link' : ''}`}
                              to={`/${url}/awaiting-returned-reports`} onClick={() => setPageTitle("گزارش در انتظار عودت مالی")}>گزارش در انتظار عودت مالی</Link></li>)}
                          {/* {userResources?.includes("BusinessDeposit") && businessByToken && businessByToken.settlementMethod === 2 &&
                              <li><Link
                              className={`sidebar-panel ${isActive('/dashboard') ? 'active-link' : ''}`}
                              to={`/${url}/balance-report`} onClick={() => setPageTitle("گردش مالی صندوق")}>گردش مالی صندوق</Link></li>
                            } */}
                        </ul>
                      </Panel>
                    }

                    {userResources &&
                      (userResources?.includes("BusinessUnderReviewReport") ||
                        (userResources?.includes("BusinessPendingPaymentRequest")) ||
                        (userResources?.includes("BusinessSaleReport")) ||
                        userResources?.includes("BusinessRejectedReport")) && (
                        <Panel
                          className="sidebar-panel"
                          showArrow={false}
                          header={
                            <span className="sidebarHeader">
                              <i className="mdi mdi-sale"></i>
                              <span>فروش</span>
                              <i className="mdi mdi-chevron-down expand-icon" />
                            </span>
                          }
                          key="3"
                          bordered={0}>
                          <ul className="sub-menu">
                            {userResources?.includes(
                              "BusinessRejectedReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/business-rejected-report') ? 'active-link' : ''}`}

                                    to={`/${url}/business-rejected-report`}
                                    onClick={() =>
                                      setPageTitle("درخواستهای رد شده")
                                    }
                                  >
                                    درخواستهای رد شده
                                  </Link>
                                </li>
                              )}
                            {userResources?.includes(
                              "BusinessSaleReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/business-canceled-report') ? 'active-link' : ''}`}

                                    to={`/${url}/business-canceled-report`}
                                    onClick={() =>
                                      setPageTitle("درخواستهای فسخ شده")
                                    }
                                  >
                                    درخواستهای فسخ شده
                                  </Link>
                                </li>
                              )}
                            {userResources?.includes(
                              "BusinessUnderReviewReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/business-under-review-report') ? 'active-link' : ''}`}

                                    to={`/${url}/business-under-review-report`}
                                    onClick={() =>
                                      setPageTitle("درخواستهای در حال بررسی")
                                    }
                                  >
                                    درخواستهای در حال بررسی
                                  </Link>
                                </li>
                              )}
                            {userResources?.includes(
                              "BusinessPendingPaymentRequest"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/business-pending-payment') ? 'active-link' : ''}`}

                                    to={`/${url}/business-pending-payment`}
                                    onClick={() =>
                                      setPageTitle("درخواستهای در انتظار پرداخت مابه تفاوت")
                                    }
                                  >
                                    در انتظار پرداخت مابه تفاوت
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </Panel>
                      )}
                    {userResources &&
                      ((userResources?.includes("BusinessIssueEndorsementReport")) ||
                        userResources?.includes("EndorsementRejectedReport") ||
                        (userResources?.includes("EndorsementUnderReviewReport")) ||
                        userResources?.includes("EndorsementPendingPaymentReport")) && (
                        <Panel
                          showArrow={false}
                          className="sidebar-panel"
                          header={
                            <span className="sidebarHeader">
                              <i className="mdi mdi-coin-outline"></i>
                              <span>الحاقیه</span>
                              <i className="mdi mdi-chevron-down expand-icon" />
                            </span>
                          }
                          key="4"
                          bordered={false}
                        >
                          <ul className="sub-menu">
                            {userResources?.includes("BusinessIssueEndorsementReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/issue-endorsement-report') ? 'active-link' : ''}`}

                                  to={`/${url}/issue-endorsement-report`}
                                  onClick={() => setPageTitle("گزارش صدور الحاقیه")}
                                >
                                  گزارش صدور الحاقیه
                                </Link>
                              </li>
                            )}
                            {userResources?.includes(
                              "EndorsementRejectedReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/endorsement/rejected-report') ? 'active-link' : ''}`}

                                    to={`/${url}/endorsement/rejected-report`}
                                    onClick={() =>
                                      setPageTitle("الحاقیه‌های رد شده")
                                    }
                                  >
                                    الحاقیه‌های رد شده
                                  </Link>
                                </li>
                              )}
                            {userResources?.includes(
                              "EndorsementUnderReviewReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/endorsement/under-review-report') ? 'active-link' : ''}`}

                                    to={`/${url}/endorsement/under-review-report`}
                                    onClick={() =>
                                      setPageTitle("الحاقیه‌های در حال بررسی")
                                    }
                                  >
                                    الحاقیه‌های در حال بررسی
                                  </Link>
                                </li>
                              )}
                            {userResources?.includes(
                              "EndorsementPendingPaymentReport"
                            ) && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/endorsement/pending-payment-report') ? 'active-link' : ''}`}

                                    to={`/${url}/endorsement/pending-payment-report`}
                                    onClick={() =>
                                      setPageTitle("الحاقیه‌های در انتظار پرداخت")
                                    }
                                  >
                                    الحاقیه‌های در انتظار پرداخت
                                  </Link>
                                </li>
                              )}
                          </ul>
                        </Panel>
                      )}

                    {userResources &&
                      (userResources?.includes("BusinessSaleReport") ||
                        userResources?.includes("UserBoughtReport") ||
                        userResources?.includes("BusinessSupportReport") ||
                        userResources?.includes("BusinessSummary")) && (
                        <Panel
                          showArrow={false}
                          className="sidebar-panel"
                          header={
                            <span className="sidebarHeader">
                              <i className="mdi mdi-checkbook"></i>
                              <span>گزارشات</span>
                              <i className="mdi mdi-chevron-down expand-icon" />
                            </span>
                          }
                          key="5"
                          bordered={0}
                        >
                          <ul className="sub-menu">
                            {userResources?.includes("BusinessSaleReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/business-sale-report') ? 'active-link' : ''}`}

                                  to={`/${url}/business-sale-report`}
                                  onClick={() => setPageTitle("گزارش فروش")} >
                                  گزارش فروش
                                </Link>
                              </li>
                            )}
                              {userResources?.includes("BusinessAdmin") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/business-installment-report') ? 'active-link' : ''}`}

                                  to={`/${url}/business-installment-report`}
                                  onClick={() => setPageTitle("گزارش اقساط")} >
                                  گزارش اقساط
                                </Link>
                              </li>
                   )} 
                            {/* {userResources?.includes("UserBoughtReport") && (
                              <li>
                                <Link
className={`sidebar-panel ${isActive('/dashboard') ? 'active-link' : ''}`}

                                  to={`/${url}/user-report`}
                                  onClick={() =>
                                    setPageTitle("گزارش خرید یک کاربر")
                                  }
                                >
                                  گزارش خرید یک کاربر
                                </Link>
                              </li>
                            )} */}
                            {userResources?.includes("BusinessSupportReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/business-support') ? 'active-link' : ''}`}

                                  to={`/${url}/business-support`}
                                  onClick={() => setPageTitle("گزارش پشتیبانی")}
                                >
                                  گزارش پشتیبانی
                                </Link>
                              </li>
                            )}
                            {userResources?.includes("BusinessRenewalReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/business-Renewal-report') ? 'active-link' : ''}`}

                                  to={`/${url}/business-Renewal-report`}
                                  onClick={() => setPageTitle(" گزارش تمدید")}
                                >
                                  گزارش تمدید
                                </Link>
                              </li>
                            )}
                            {userResources?.includes("companySaleReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/company-sale-report') ? 'active-link' : ''}`}

                                  to={`/${url}/company-sale-report`}
                                  onClick={() => setPageTitle("  گزارش فروش شرکت")}
                                >
                                  گزارش فروش شرکت
                                </Link>
                              </li>
                            )}
                            {(
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/page-log-daily-report') ? 'active-link' : ''}`}

                                  to={`/${url}/page-log-daily-report`}
                                  onClick={() => setPageTitle("گزارش بازدید")}
                                >
                                  گزارش بازدید
                                </Link>
                              </li>
                            )}
                            {userResources?.includes("BusinessPlaqueInquiryReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/plaque-report') ? 'active-link' : ''}`}

                                  to={`/${url}/plaque-report`}
                                  onClick={() => setPageTitle("گزارش استعلام پلاک")}
                                >
                                  گزارش استعلام پلاک
                                </Link>
                              </li>
                            )}
                            {userResources?.includes("BusinessSaleReport") && (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/white-lable-settelment-fund-report') ? 'active-link' : ''}`}

                                  to={`/${url}/white-lable-settelment-fund-report`}
                                  onClick={() => setPageTitle("گزارش تراکنش")}
                                >
                                  گزارش تراکنش
                                </Link>
                              </li>
                            )}
                            {userResources &&
                              userResources?.includes("BusinessSummary") && (
                                <li>
                                  <Link
                                    className={`sidebar-panel ${isActive('/dashboard/business-dashboard') ? 'active-link' : ''}`}

                                    to={`/${url}/business-dashboard`}
                                    onClick={() =>
                                      setPageTitle("خلاصه عملکرد سازمان")
                                    }
                                  >
                                    خلاصه عملکرد سازمان
                                  </Link>
                                </li>
                              )}

                          </ul>
                        </Panel>
                      )}
                    {(((userResources?.includes("TicketManagment") && hasTicketingService) ||
                      (userResources?.includes("CRM") && userResources?.includes("Search-Promoter-Users")) ||
                      userResources?.includes("OTPReport") || userResources?.includes("UserBusinessReport"))) &&
                      <Panel
                        className="sidebar-panel"
                        showArrow={false}
                        header={
                          <span className="sidebarHeader">
                            <i className="mdi mdi-contacts"></i>
                            <span>پشتیبانی</span>
                            <i className="mdi mdi-chevron-down expand-icon" />
                          </span>
                        }
                        key="6"
                        bordered={0}
                      >
                        <ul className="sub-menu">

                          {userResources?.includes("CRM") &&
                            userResources?.includes("Search-Promoter-Users") &&
                            (
                              <li>
                                <Link
                                  className={`sidebar-panel ${isActive('/dashboard/promoter-users') ? 'active-link' : ''}`}

                                  to={`/${url}/promoter-users`}
                                  onClick={() =>
                                    setPageTitle("جستجوی بازاریاب")
                                  }
                                >
                                  جستجوی بازاریاب
                                </Link>
                              </li>
                            )}

                          {userResources?.includes("UserBusinessReport") &&
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/user-business-report') ? 'active-link' : ''}`}

                                to={`/${url}/user-business-report`}
                                onClick={() => setPageTitle("جست و جوی کاربر")}>
                                جست و جوی کاربر
                              </Link>
                            </li>}
                          {userResources?.includes("UserBusinessReport") &&
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/call-history') ? 'active-link' : ''}`}

                                to={`/${url}/call-history`}
                                onClick={() => setPageTitle("گزارش تماس")}>
                                گزارش تماس
                              </Link>
                            </li>}
                          {userResources?.includes("UserBusinessReport") &&
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/my-call-histories') ? 'active-link' : ''}`}

                                to={`/${url}/my-call-histories`}
                                onClick={() => setPageTitle("تماس های من")}>
                                تماس های من
                              </Link>
                            </li>}
                          {userResources?.includes("TicketManagment") && hasTicketingService && <>
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/open-tickets') ? 'active-link' : ''}`}

                                to={`/${url}/open-tickets`}
                                onClick={() => setPageTitle("تیکت‌های باز")}
                              >
                                تیکت‌های باز
                              </Link>
                            </li>
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/close-tickets') ? 'active-link' : ''}`}

                                to={`/${url}/close-tickets`}
                                onClick={() => setPageTitle("تیکت‌های بسته")}
                              >
                                تیکت‌های بسته
                              </Link>
                            </li>
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/contact-us') ? 'active-link' : ''}`}

                                to={`/${url}/contact-us`}
                                onClick={() => setPageTitle("تماس با ما")}
                              >
                                تماس با ما
                              </Link>
                            </li></>}
                          {userResources?.includes("OTPReport") &&
                            <li>
                              <Link
                                className={`sidebar-panel ${isActive('/dashboard/otp-report') ? 'active-link' : ''}`}

                                to={`/${url}/otp-report`}
                                onClick={() => setPageTitle(" گزارش otp")}
                              >
                                گزارش otp
                              </Link>
                            </li>}
                        </ul>
                      </Panel>
                    }
                    {userResources?.includes("BusinessSaleReport") &&
                      <Panel
                        className="sidebar-panel"
                        header={
                          <span className="sidebarHeader">
                            <i className="mdi mdi-android-messages"></i>
                            <span>فاکتور ها</span>
                            <i className="mdi mdi-chevron-down expand-icon" />
                          </span>
                        }
                        showArrow={false}
                        key="7"
                        bordered={0}
                      >
                        <ul className="sub-menu">
                          <li>
                            <Link
                              className={`sidebar-panel ${isActive('/dashboard/receipts') ? 'active-link' : ''}`}

                              to={`/${url}/receipts`}
                              onClick={() => setPageTitle("فاکتورها")}
                            >
                              <span>فاکتورها</span>
                            </Link>
                          </li>
                          <li>
                            <Link
                              className={`sidebar-panel ${isActive('/dashboard/receipts-report') ? 'active-link' : ''}`}

                              to={`/${url}/receipts-report`}
                              onClick={() => setPageTitle("گزارش پشتیبانی فاکتورها")}
                            >
                              <span>گزارش پشتیبانی</span>
                            </Link>
                          </li>
                        </ul>
                      </Panel>
                    }
                  </Collapse>
                </li>
                <li>
                  <Link
                    className={`sidebar-panel ${isActive('/dashboard/notifications') ? 'active-link' : ''}`}

                    // className="sidebar-panel"
                    to={`/${url}/notifications`}
                    onClick={() => setPageTitle("اعلان ها")}
                  >
                    <span className="sidebarHeader">
                      <i className="mdi mdi-bell-outline"></i>
                      <span className="title">اعلان ها</span>
                    </span>
                  </Link>
                </li>
                <li>
                  <Link
                    className={`sidebar-panel ${isActive('/dashboard') ? '' : ''}`}
                    to={`/`}
                    // className="sidebar-panel"
                    onClick={() => {
                      logOut()
                      RESET_APP()
                    }}>
                    <span className="sidebarHeader">
                      <i className="mdi mdi-location-exit"></i>
                      <span className="title">خروج</span>
                    </span>
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <Content
          Title={pageTitle}
          showSearch={isHomePage}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          showGridToggle={isHomePage && !isCompactView}
          gridCols={gridCols}
          onGridColsChange={handleGridColsChange}
          showCategoryFilter={isHomePage}
          selectedCategory={selectedCategory}
          onCategoryChange={setSelectedCategory}
        >
          <Routes>
            {userResources?.includes("SeoManagment") && <Route path={"seo"} element={<Seo />} />}
            {userResources?.includes("CompanyFeedback") && <Route path="feedback" element={<Feedback />} />}
            {userResources?.includes("BlogManagment") && <Route path="posts" element={<BlogPosts />} />}
            {userResources?.includes("BusinessesManagment") && <Route path="businesses" element={<Businesses />} />}
            {userResources?.includes("UserManagment") && <Route path="users/:pageNumber" element={<Users />} />}
            {userResources?.includes("UserBusinessReport") && (
              <>
                <Route path="/user-business-report" element={<UsersBusinessReport />} />
                <Route path="/call-history" element={<CallHistory />} />
                <Route path="/my-call-histories" element={<MyCallHistories />} />
              </>
            )}
            {hasTicketingService && userResources?.includes("TicketManagment") && (
              <>
                <Route path="/open-tickets" element={<OpenTickets />} />
                <Route path="/close-tickets" element={<CloseTickets />} />
                <Route path="/contact-us" element={<ContactUs />} />
              </>
            )}
            {userResources?.includes("BusinessSaleReport") && (
              <>
                <Route path="receipts" element={<Receipts />} />
                <Route path="receipts-report" element={<ReceiptsReport />} />
                <Route path="business-sale-report" element={<BusinessSaleReport />} />
              </>
            )}
            {userResources?.includes("BusinessAdmin") && (
              <>
                <Route path="receipts" element={<Receipts />} />
                <Route path="receipts-report" element={<ReceiptsReport />} />
                <Route path="business-installment-report" element={<BusinessInstallmentReport />} />
              </>
            )} 
            {userResources?.includes("OTPReport") && <Route path="otp-report" element={<BusinessOtpReport />} />}
            {userResources?.includes("BusinessSummary") && <Route path="business-dashboard" element={<BusinessDashboard />} />}

            {isMarketer && userResources?.includes("MarketersPaid") && <Route path="agents-paid" element={<AgentPaid />} />}
            {userResources?.includes("UserBoughtReport") && <Route path="user-report" element={<UserReport />} />}
            {userResources?.includes("BusinessRejectedReport") && <Route path="business-rejected-report" element={<BusinessRejectedReport />} />}
            {userResources?.includes("BusinessUnderReviewReport") && <Route path="business-under-review-report" element={<BusinessUnderReviewReport />} />}
            {userResources?.includes("EndorsementRejectedReport") && <Route path="endorsement/rejected-report" element={<EndorsementRejectedReport />} />}
            {userResources?.includes("EndorsementUnderReviewReport") && <Route path="endorsement/under-review-report" element={<EndorsementUnderReviewReport />} />}
            {userResources?.includes("BusinessSupportReport") && <Route path="business-support" element={<BusinessSupport />} />}
            {userResources?.includes("BusinessRenewalReport") && <Route path="business-Renewal-report" element={<BusinessRenewalReport />} />}
            {userResources?.includes("companySaleReport") && <Route path="company-sale-report" element={<CompanySaleReport />} />}
            {userResources?.includes("PageLogDailyReport") && <Route path="page-log-daily-report" element={<PageLogReport />} />}
            {userResources && userResources?.includes("BusinessSaleReport") && (
              <Route exact path={`/business-canceled-report`} element={<BusinessCanceledReport />} />
            )}

            {userResources && userResources?.includes("BusinessPendingPaymentRequest") && <Route path="business-pending-payment" element={<BusinessPendingPayment />} />}
            {userResources && userResources?.includes("BusinessIssueEndorsementReport") && <Route exact path="issue-endorsement-report" element={<IssueEndorsementReport />} />}
            {userResources && userResources?.includes("EndorsementPendingPaymentReport") && <Route exact path="/endorsement/pending-payment-report" element={<EndorsementPendingPaymentReport />} />}
            {userResources && userResources?.includes("BusinessSaleReport") && (
              <Route exact path={`/white-lable-settelment-fund-report`} element={<WLFundReport />} />
            )}
            {userResources?.includes("BusinessPlaqueInquiryReport") && (
              <Route exact path={`/plaque-report`} element={<PlaqueReport />} />

            )}
            {userResources && userResources?.includes("MarketersReports") && (
              <Route path={`/marketers-list`} element={<MarketersList />} />

            )}
            {userResources &&
              userResources?.includes("OTPReport") && (
                <Route path={`/otp-report`} element={<BusinessOtpReport />} />
              )}
            {isMarketer &&
              userResources &&
              userResources?.includes("MarketersReports") && (
                <Route exact path={`/marketers-remain-report`} element={<MarketerBalanceReport />} />

              )}
            {isMarketer &&
              userResources &&
              userResources?.includes("MarketersReports") && (
                <Route path={`/agents-balance`} element={<AgentsBalance />} />
              )}
            {userResources && userResources?.includes("UserBoughtReport") && (
              <Route exact path={`/user-report`} element={<UserReport />} />
            )}
            {userResources?.includes("BusinessDeposit") && (
              <>
                <Route path="returned-reports" element={<ReturnedReports />} />
                <Route path="/awaiting-returned-reports" element={<WaitingToReturn />} />
              </>
            )}
            <Route path="notifications" element={<Notifications />} />
            {userResources?.includes("BusinessesManagment") && (
              <Route path="external-login-test" element={<ExternalLoginTest />} />
            )}
            <Route path="profile" element={<Profile />} />
            <Route path="changePassword" element={<ChangePassword />} />
            {userInfo?.Resources?.includes("AddSliderImage") && <Route path="slidesManagmanet" element={<SlidesManagement />} />}
            {userInfo?.Resources?.includes("EditDesign") && updateBusinessResource && <Route path="whiteLabelSettings" element={<WhiteLabelSettings />} />}
            {isMarketer && userInfo?.Resources?.includes("BusinessAdmin") && <Route path="marketerWageSettings" element={<MarketerWageSettings />} />}

            {
              userResources?.includes("CRM") &&
              userResources?.includes("Search-Promoter-Users") &&
              (
                <Route path="promoter-users"
                  element={<PromoterUsersReport />}
                />
              )}
            <Route path="/" element={<MainContent
              onPageTile={(title) => handleTitle(title)}
              hasTicketingService={hasTicketingService}
              isMarketer={isMarketer}
              searchTerm={searchTerm}
              gridCols={gridCols}
              selectedCategory={selectedCategory} />} />


            {/* <Route path="*" element={<NotFound />} /> */}

          </Routes>
        </Content>
      </Layout>
    </div>
  );
}
